import styled from '@emotion/styled';
import { getDefaultTextProps } from '../shared.styles';
import { EmotionTextProps } from '../types';

export const StyledText = styled.span<EmotionTextProps>`
  ${(props) => getDefaultTextProps(props)}
`;
